'use client';
import PropTypes from 'prop-types';
import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {IconX} from '@tabler/icons-react';
import {
  Button,
  Divider,
  FormHelperText,
  Grid,
  Switch,
  Typography,
} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const List = ({name, values, errors}) => {
  const [fileLoading, setFileLoading] = useState(false);

  const {setValue} = useFormContext();

  const removeActivity = ({activityIndex}) => {
    setValue(
      name,
      (values || []).filter((_, ind) => ind !== activityIndex)
    );
  };

  const addActivity = () =>
    setValue(name, [
      ...(values || []),
      {
        isIncluded: false,
        title: {en: '', nl: ''},
        description: {en: '', nl: ''},
        image: '',
      },
    ]);

  const handleIsIncluded = ({activityIndex, isIncluded}) => {
    values?.map((act, ind) => {
      if (ind === activityIndex) {
        setValue(`${name}[${ind}].isIncluded`, isIncluded);
      } else {
        setValue(`${name}[${ind}].isIncluded`, false);
      }
    });
  };

  return (
    <Grid>
      {values?.map((activity, activityIndex) => {
        return (
          <Grid key={activity.id || `activity-${activityIndex}`}>
            <Grid>
              <Grid
                display='flex'
                alignItems='center'
                justifyContent={'space-between'}
                mb={2}
              >
                <Typography variant='h6'>
                  {activityIndex + 1}. Activity Title
                </Typography>
                <Grid display='flex' alignItems='center'>
                  Is Included
                  <Switch
                    checked={activity?.isIncluded}
                    onChange={(event) =>
                      handleIsIncluded({
                        activityIndex,
                        isIncluded: event.target.checked,
                      })
                    }
                  />
                  <IconX
                    color='red'
                    onClick={() => removeActivity({activityIndex})}
                  />
                </Grid>
              </Grid>

              <RHFMultilingualField name={`${name}[${activityIndex}].title`} />
            </Grid>

            <Typography variant='h6' mb={2}>
              Description
            </Typography>

            <RHFMultilingualField
              name={`${name}[${activityIndex}].description`}
            />

            <Typography variant='h6' mb={2}>
              Image
            </Typography>

            <Grid sx={{width: '50%'}}>
              <FileUploader
                meta={{shape: 'Rectangle', size: {width: 300, height: 340}}}
                label={'Activity Image'}
                name={`${name}[${activityIndex}].image`}
                setFileUrl={(links) =>
                  setValue(`${name}[${activityIndex}].image`, links[0])
                }
                destination={'landing-pages'}
                values={values?.[activityIndex]?.image}
                setFileLoading={setFileLoading}
                setValue={setValue}
              />
            </Grid>

            <Divider sx={{my: 2}} />
          </Grid>
        );
      })}

      <center>
        <Button size='small' color={'error'} onClick={() => addActivity()}>
          Add New Activity
        </Button>
      </center>

      {errors && (
        <FormHelperText sx={{color: 'error.main', ml: -0.01, mb: 1}}>
          {errors?.message}
        </FormHelperText>
      )}
    </Grid>
  );
};

List.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array,
  errors: PropTypes.object,
};
